"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var config_1 = __importDefault(require("config"));
var api_1 = __importDefault(require("api"));
var use_notification_1 = require("hooks/use-notification");
var Notification_1 = require("components/core/Notification");
var UserStore_1 = __importDefault(require("stores/UserStore"));
var LoginForm_1 = __importDefault(require("./LoginForm"));
var Login = function () {
    var _a = react_1.useState({
        username: "",
        password: ""
    }), userData = _a[0], setUserData = _a[1];
    var _b = react_1.useState(false), busy = _b[0], setBusy = _b[1];
    var notification = use_notification_1.useNotification();
    var history = react_router_dom_1.useHistory();
    var changeHandler = function (e) {
        var _a;
        setUserData(__assign(__assign({}, userData), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    var submitHandler = function (e) {
        e.preventDefault();
        var busyTimeout = setTimeout(function () {
            setBusy(true);
        }, config_1.default.busyDelay);
        var error = null;
        for (var k in userData) {
            if (userData.hasOwnProperty(k)) {
                if (userData[k].length <= 0) {
                    error = "Please enter your " + k;
                    break;
                }
            }
        }
        if (error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error
            });
            clearTimeout(busyTimeout);
            return;
        }
        api_1.default.login(userData)
            .then(function (response) {
            clearTimeout(busyTimeout);
            setBusy(false);
            UserStore_1.default.setData(response.data);
            history.replace("/");
        }, function (error) {
            clearTimeout(busyTimeout);
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error.response.data.error
            });
        })
            .catch(function (error) {
            clearTimeout(busyTimeout);
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error.response.data.error
            });
        });
    };
    return (react_1.default.createElement("div", { className: "login flex flex-column flex-center" },
        react_1.default.createElement(LoginForm_1.default, { userData: userData, onChange: changeHandler, onSubmit: submitHandler, busy: busy })));
};
exports.default = Login;
